import { ref } from 'vue';
import { defineRouter } from '#q-app/wrappers';
import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router';
import routes from './routes';
import * as storageService from 'src/services/storage';
import * as tracking from 'src/services/tracking';

// @note Transition name consumed by App.vue. Empty string disables the
// transition entirely (no classes, no leave/enter cycle) — we use that on
// native browser back/forward so iOS swipe-back doesn't trigger a flash.
export const transitionName = ref('');

let isBrowserPop = false;
if (typeof window !== 'undefined') {
  window.addEventListener('popstate', () => {
    isBrowserPop = true;
  });
}

export default defineRouter(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history'
      ? createWebHistory
      : createWebHashHistory;

  const Router = createRouter({
    scrollBehavior: (_to, _from, savedPosition) => savedPosition ?? { left: 0, top: 0 },
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE),
  });

  Router.beforeEach((to, from, next) => {
    transitionName.value = isBrowserPop ? '' : 'page-fade';

    const isLoggedIn = storageService.isLoggedIn();

    if (to.meta.requiresAuth && !isLoggedIn) {
      storageService.setRedirectAfterAuth(to.fullPath);
      next({ name: 'auth-login' });
      return;
    }

    if (to.meta.guestOnly && isLoggedIn) {
      next({ name: 'explore' });
      return;
    }

    next();
  });

  Router.afterEach((to) => {
    isBrowserPop = false;
    tracking.trackPageView({ path: to.fullPath });
  });

  return Router;
});
